import React from "react"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { haveAuth } from "utils"
import { changeDeliveryType, hideFoodSearchBar, hideFoodSidebar } from "@redux"
import classes from "./FoodSidebarCheckoutButton.module.scss"

const FoodSidebarCheckoutButton = () => {
  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const order =
    useSelector(state => state.order)

  const serviceTypeName =
    useSelector(state => state.systemSettings.serviceTypeName)

  const validate = () => {
    const isCartEmpty =
      order.items.length === 0 &&
      order.combos.length === 0

    if (isCartEmpty) {
      toast.error("لطفا_یک_کالا_انتخاب_کنید", { autoClose: false })

      return false
    }

    return true
  }

  const handleGoToPlaceOrder = () => {
    if (!validate()) return

    dispatch(
      changeDeliveryType("dineIn")
    )

    dispatch(
      hideFoodSidebar()
    )

    dispatch(
      hideFoodSearchBar()
    )

    history.push("/place-order")
  }

  const handleGoToCheckout = () => {
    if (!validate()) return

    dispatch(
      changeDeliveryType("dineIn")
    )

    dispatch(
      hideFoodSidebar()
    )

    dispatch(
      hideFoodSearchBar()
    )

    history.push("/checkout")
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["row"]}>
      {
        serviceTypeName === "shop" &&
        haveAuth(["placeOrder"]) &&
        <button
          onClick={handleGoToPlaceOrder}
          className={classes["button"]}
        >
          <span>{t("ثبت_سفارش")}</span>
        </button>
      }
      {
        haveAuth(["checkout"]) &&
        <button
          onClick={handleGoToCheckout}
          className={clsx(classes["button"], isLtr && classes["button-ltr"])}
        >
          <span>{t("پرداخت")}</span>
        </button>
      }
    </div>

  )
}

export default React.memo(FoodSidebarCheckoutButton)